"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";

// tracktor pulls in libsodium (~330KB gzip with its crypto polyfills). Nothing on
// the site reads its context, so it is mounted on its own, after the page has
// loaded and the browser is idle, instead of wrapping the app and landing in the
// first JS bundle. Web-vitals entries are buffered, so it still sees FCP/LCP.
const TracktorProvider = dynamic(
  () => import("@shakhearacom/tracktor/react").then((m) => m.TracktorProvider),
  { ssr: false }
);

const TracktorLoader = (props) => {
  const [ready, set_ready] = useState(false);

  useEffect(() => {
    let idle_id = null;
    let timer_id = null;

    const start = () => {
      if ("requestIdleCallback" in window) {
        idle_id = window.requestIdleCallback(() => set_ready(true), { timeout: 4000 });
      } else {
        timer_id = window.setTimeout(() => set_ready(true), 2000);
      }
    };

    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });

    return () => {
      window.removeEventListener("load", start);
      if (idle_id !== null) window.cancelIdleCallback(idle_id);
      if (timer_id !== null) window.clearTimeout(timer_id);
    };
  }, []);

  return ready ? <TracktorProvider {...props} /> : null;
};

export default TracktorLoader;
